// extracted by mini-css-extract-plugin
module.exports = {"container":"style_container__1o2oQ","card":"style_card__18evP","title":"style_title__2me3v","body":"style_body__12L1J"};